export type ElementSize = 'sm' | 'lg';

export const ElementSize = {
    SM: 'sm' as ElementSize,
    LG: 'lg' as ElementSize
};